export const GROUP_CHAT_BOT_ID = 'bot:ai'

export interface OrgDeptNode {
  id: string
  label: string
  children?: OrgDeptNode[]
}

export interface OrgPerson {
  id: string
  name: string
  title: string
  deptId: string
  deptName: string
  username?: string
  email?: string
}

export const MOCK_GROUP_DEPTS: OrgDeptNode[] = [
  {
    id: 'company',
    label: '崇达技术',
    children: [
      { id: 'sz', label: '深圳工厂' },
      { id: 'jm', label: '江门工厂' },
      { id: 'dl', label: '大连工厂' },
      { id: 'zh', label: '珠海工厂' },
      { id: 'tech-group', label: '集团技术部' },
      { id: 'it', label: '信息部' },
      { id: 'sales', label: '销售部' },
      { id: 'equip', label: '设备部' },
    ],
  },
]

export const MOCK_GROUP_PERSONS: OrgPerson[] = [
  { id: 'p1', name: '周国庆', title: '信息经理', deptId: 'it', deptName: '信息部', username: 'zgq', email: 'zgq@example.com' },
  { id: 'p2', name: '唐立杰', title: '应用开发工程师', deptId: 'it', deptName: '信息部', username: 'tlj', email: 'tlj@example.com' },
  { id: 'p3', name: '吴予骥', title: '办公信息化', deptId: 'it', deptName: '信息部', username: 'wyj', email: 'wyj@example.com' },
  { id: 'p4', name: '李晓明', title: '人事专员', deptId: 'sz', deptName: '深圳工厂', username: 'lxm', email: 'lxm@example.com' },
  { id: 'p5', name: '王芳', title: '财务主管', deptId: 'tech-group', deptName: '集团技术部', username: 'wf', email: 'wf@example.com' },
  { id: 'p6', name: '陈静', title: '销售经理', deptId: 'sales', deptName: '销售部', username: 'cj', email: 'cj@example.com' },
  { id: 'p7', name: '赵强', title: '设备主管', deptId: 'equip', deptName: '设备部', username: 'zq', email: 'zq@example.com' },
]

export type GroupChatNodeKind = 'company' | 'dept' | 'user' | 'bot'

export interface GroupChatNode {
  id: string
  label: string
  kind: GroupChatNodeKind
  children?: GroupChatNode[]
}

export interface GroupChatMember {
  id: string
  name: string
  kind: GroupChatNodeKind
  username?: string
  email?: string
}

export function attachUsersToDepts(
  depts: OrgDeptNode[],
  persons: OrgPerson[]
): GroupChatNode[] {
  return depts.map((dept) => {
    const nested = dept.children?.length
      ? attachUsersToDepts(dept.children, persons)
      : []
    const users: GroupChatNode[] = persons
      .filter((person) => person.deptId === dept.id)
      .map((person) => ({
        id: `user:${person.id}`,
        label: person.name,
        kind: 'user' as const,
      }))
    const children = [...nested, ...users]
    return {
      id: `dept:${dept.id}`,
      label: dept.label,
      kind: dept.children?.length ? 'company' : 'dept',
      children: children.length ? children : undefined,
    }
  })
}

export function wrapCompanyTree(
  depts: OrgDeptNode[],
  persons: OrgPerson[],
  companyName: string
): GroupChatNode[] {
  const children = attachUsersToDepts(depts, persons)
  if (children.length === 1 && children[0].kind === 'company') {
    return children
  }
  return [
    {
      id: 'company:root',
      label: companyName,
      kind: 'company',
      children,
    },
  ]
}

/** 展开组织节点；人员的直接上级保持折叠 */
export function collectExpandedOrgKeys(nodes: GroupChatNode[]): string[] {
  const keys: string[] = []
  const walk = (list: GroupChatNode[]) => {
    for (const node of list) {
      const children = node.children
      if (!children?.length) continue
      if (!children.some((child) => child.kind === 'user')) {
        keys.push(node.id)
      }
      walk(children)
    }
  }
  walk(nodes)
  return keys
}
